<template>
  <div class="frmware-detail-table-bd">
    <h2 class="table-title">
      {{ i18n.label_device_msg }}
    </h2>
    <div class="table-bd">
      <!-- {{tableColumn}} -->
      <custom-table
        :data="data"
        :loading="isLoading"
        :column="tableColumn"
        :tableCode="tableCode"
        :index="true"
        :slots="['deviceMsg', 'returnContent', 'progress','action']"
        @filter="filterChange"
        @sort="sortChange"
        :filterArr="`${serviceType}` !== '3' ? ['progress','action'] : []"
      >
        <template
          slot="deviceMsg"
          slot-scope="scope"
        >
          <el-popover
            placement="top-start"
            trigger="hover"
          >
            <ul>
              <li class="cell-pop-item">{{ i18n.label_biz_state }}： {{ scope.row.bizState || '-' }}</li>
              <li class="cell-pop-item">{{ i18n.label_after_service_name }}： {{ scope.row.afterServiceName || '-' }}</li>
              <li class="cell-pop-item">{{ i18n.label_agent_co_name }}： {{ scope.row.agentCoName || '-' }}</li>
              <li class="cell-pop-item">{{ i18n.page_content_customer }}： {{ scope.row.customerName || '-' }}</li>
              <li class="cell-pop-item">{{ i18n.label_user_location }}： {{ scope.row.useLocation || '-' }}</li>
            </ul>
            <div
              class="cell-pop"
              slot="reference"
            >{{ i18n.com_detail }}</div>
          </el-popover>
        </template>
        <template
          slot="returnContent"
          slot-scope="scope"
        >
          <el-popover
            placement="top-start"
            trigger="hover"
          >
            <ul>
              <li class="cell-pop-item">{{ scope.row.returnContent }}</li>
            </ul>
            <div
              class="cell-pop"
              slot="reference"
              v-if="scope.row.returnContent"
            >{{ i18n.com_detail }}</div>
          </el-popover>
        </template>
        <template v-slot:progress="scope">
          <span>
            {{getDicValue('iot_cmd_task_progress_type', scope.row.progressType)}} {{scope.row.progressValue}}<span v-if="scope.row.progressValue">%</span>
          </span>
        </template>
         <template slot="action" slot-scope="scope">
          <el-button v-if="scope.row.executeState===3" type="text" size="mini" @click="onCancelRow(scope.row.taskDetailId )">{{i18n.com_cancel}}</el-button>
          <!-- <el-button v-if="scope.row.executeState===0||scope.row.executeState===4" type="text" size="mini" @click="onDeleteRow(scope.row.taskDetailId )">{{i18n.com_delete}}</el-button> -->
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTable from '@/components/customTable.vue';

export default {
  components: { customTable },
  props: {
    data: [String, Object, Array],
    serviceType: [String, Number],
  },
  computed: {
    showProgress() {
      return `${this.serviceType}` === '3';
    },
  },

  data() {
    return {
      tableCode: 'firmware_task_device_detail',
    };
  },
  mounted() {
    this.getTableColumn();
  },
  methods: {
    // 取消
    onCancelRow: function (id) {
      this.$showConfirm(this.i18n.cf_tips_cencel_cur_task)
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailCancel}/${id}`).then(() => {
            this.$message({
              message: this.i18n.com_handle_success,
              type: 'success'
            });
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 删除
    onDeleteRow: function (id) {
      this.$showConfirm(this.i18n.cf_tips_delet_cur_task)
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailDelete}/${id}`).then(() => {
            this.$message({
              message: this.i18n.com_delete_success,
              type: 'success'
            });
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.frmware-detail-table-bd {
  .table-box {
    flex: 1;
    .table-title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }

    .table-bd {
      height: 100%;
    }
  }
}
</style>
